import { loadContentDetails } from '../content-details'

/**
 * Loads dependent content details
 * Loads content details for dependent request flow
 */
export async function loadDependentContent(id: number) {
  return loadContentDetails(id)
}
